import _ from 'lodash'
import { utils } from 'frontend-js-shared'

import {
  normalizeChecklistItems,
  collectSignatureSignerIds,
  attachResolvedSignatureSignerNames,
  withUnresolvedSignatureSignerNames
} from './signatureUtils'

const getAccountSelectionId = response => {
  const selectedValue = Array.isArray(response) ? response[0] : response

  return utils.getEntityId(selectedValue)
}

export const collectAccountSelectionIds = (items = []) => {
  return _.uniq(
    items
      .filter(item => item?.type === 'accountSelection')
      .map(item => getAccountSelectionId(item?.response))
      .filter(Boolean)
  )
}

export const attachResolvedAccounts = (items = [], accountsById = new Map()) => {
  return items.map(item => {
    if (item?.type !== 'accountSelection') return item

    const firstId = getAccountSelectionId(item?.response)

    return {
      ...item,
      resolvedAccounts:
        firstId && accountsById.has(firstId) ? [accountsById.get(firstId)] : [],
    }
  })
}

export const withEmptyResolvedAccounts = (items = []) => {
  return items.map(item => {
    if (item?.type !== 'accountSelection') return item

    return {
      ...item,
      resolvedAccounts: [],
    }
  })
}

const buildHydrationFallbackResult = normalizedItems => {
  const itemsWithEmptyResolvedAccounts = withEmptyResolvedAccounts(
    normalizedItems
  )

  return {
    status: 'fallback',
    items: withUnresolvedSignatureSignerNames(itemsWithEmptyResolvedAccounts),
  }
}

export const hydrateChecklistItems = async (
  items = [],
  fetchAccountsByIds = async () => []
) => {
  const normalizedItems = normalizeChecklistItems(items)
  const accountIds = collectAccountSelectionIds(items)
  const signatureSignerIds = collectSignatureSignerIds(normalizedItems)
  const idsToResolve = _.uniq([...accountIds, ...signatureSignerIds])

  if (_.isEmpty(idsToResolve)) {
    return {
      status: 'skipped',
      items: normalizedItems,
    }
  }

  try {
    const accounts = (await fetchAccountsByIds(idsToResolve)) || []
    const accountsById = new Map(
      accounts.map(account => [utils.getEntityId(account), account])
    )

    const itemsWithResolvedAccounts = attachResolvedAccounts(
      normalizedItems,
      accountsById
    )

    return {
      status: 'hydrated',
      items: attachResolvedSignatureSignerNames(
        itemsWithResolvedAccounts,
        accountsById
      ),
    }
  } catch {
    return buildHydrationFallbackResult(normalizedItems)
  }
}
